<template>
	<div class="single-post" v-if="currentPage">
		<div class="main-content">
			<div class="post-header">
				<div class="title-line">
					<h2 v-html="currentPage.title.rendered"></h2>
					<wpLink 
                    :url="archive" 
					:type="true"
                    v-html="'Se alle aktuelle saker'" />
				</div>
				<p class="intro" v-if="currentPage.acf.post_intro" v-html="currentPage.acf.post_intro"></p>
			</div>
			<div class="inner">
				<div class="post-content" v-if="currentPage.acf.content">
					<DynamicHtml :html="currentPage.acf.content" />
				</div>
				<div class="post-sidebar" v-if="currentPage.acf && currentPage.acf._category">
					<div class="inner">
						<div class="date">
							<p class="label" v-html="'Dato'"></p>
							<p>{{currentPage.date | formatDate}}</p>
						</div>
						<Categories
							:categories="currentPage.acf._category" />
					</div>
					
				</div>
			</div>
		</div>
	</div>
	<div v-else class="nothing single-post"></div>
</template>

<script>
import wpLink from '@/components/navigation/WpLink'
import Categories from '@/components/blocks/CategoriesBlock'

import { mapActions } from 'vuex'

export default {
	name: 'single-post',
	components: {
		Categories,
		wpLink
	},
	data(){
		return {
			type: null,
			archive: this.$route.meta.archive,
		}
	},
}
</script>
